import { NextSeo } from 'next-seo';
import styled from 'styled-components';

import { useTranslation } from '@hooks';
import {
    AgreementModalWrapper,
    StaticPageContainer,
    StaticPageWrapper,
} from '@components/styles/StaticPagesStyles';
import {
    ContractPageLayout,
    KVKKMenu,
    StaticPagesTextContainer,
} from '@components/contracts';
import { BackButton } from '@components/ui';
import { Text3, Subtitle3, Caption } from '@components/styles/Typography';

const CookiePolicy = () => {
    const { t, locale } = useTranslation();
    return (
        <div>
            <NextSeo
                title={`Fervente | ${t('cookiePolicy')}`}
                description={t('cookiePolicyMetaDesc')}
            />
            <AgreementModalWrapper>
                {locale === 'tr' ? (
                    <ContractPageLayout title={t('cookiePolicy').toUpperCase()}>
                        <KVKKMenu activeMenu="cookie-policy" />
                        <StaticPageWrapper marginTop="0" marginTopMobile="0">
                            <StaticPageContainer>
                                <BackButton
                                    title={t('cookiePolicy').toUpperCase()}
                                    tabletHide
                                />
                                <StaticPagesTextContainer>
                                    <Text3>
                                        KEİKEİ TEKSTİL VE GİYİM SANAYİ TİCARET
                                        ANONİM ŞİRKETİ (“KEİKEİ” veya “Şirket”)
                                        olarak https://www.keikei.com/ internet
                                        sitemizde (&#34;İnternet Sitesi&#34;)
                                        internet ortamındaki faaliyetlerimiz
                                        kapsamında birtakım çerezler
                                        kullanmaktayız. İşbu Çerez Politikasının
                                        amacı, hangi tür çerezleri ne amaçlarla
                                        kullandığımızı, çerezleri nasıl
                                        yönettiğimizi, çerezlere karşı hangi
                                        işlemleri ne şekilde yapabileceğinizi
                                        sizlere açıklamaktır.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            • ÇEREZ (COOKİE) NEDİR?
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Çerezler, ziyaret ettiğiniz internet
                                        siteleri tarafından tarayıcılar
                                        vasıtasıyla bilgisayarınıza (veya akıllı
                                        telefon ya da tablet vb. diğer
                                        cihazlarınıza) kaydedilen, genelde harf
                                        ve rakamlardan oluşan metin
                                        dosyalarıdır. Çerezler, ziyaret
                                        ettiğiniz internet sitesini yöneten
                                        sunucular tarafından oluşturulurlar ve
                                        ziyaretçilere ilişkin isim, cinsiyet
                                        veya adres gibi kişisel verileri
                                        içermezler. Tarayıcınız ve sunucu
                                        arasında bir bağlantı sağlandığında
                                        site, çerezler aracılığıyla sizi tanır.
                                        Bu sayede internet sitesi size
                                        iletilecek içeriği tayin edebilir.
                                        Çerezler siteyi daha kullanışlı hale
                                        getirdikleri ve web kullanımını
                                        kolaylaştırdıkları için gerekli ve
                                        önemlidir.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            • ÇEREZLERİN KULLANIM AMAÇLARI
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        İnternet sitemizde çerez kullanılmasının
                                        başlıca amaçları şunlardır:
                                    </Text3>
                                    <Text3>
                                        • İnternet Sitesinin işlevselliğini ve
                                        performansını arttırmak yoluyla sizlere
                                        sunulan hizmetleri geliştirmek,
                                    </Text3>
                                    <Text3>
                                        • İnternet Sitesi&#39;nin nasıl
                                        kullanıldığına dair istatistiksel olarak
                                        veri toplayabilmek ve bu sayede İnternet
                                        Sitesi&#39;nin içeriğini geliştirebilmek
                                        ve işleyişi daha iyiye taşıyabilmek,
                                    </Text3>
                                    <Text3>
                                        • İnternet Sitesi üzerinde hangi içeriği
                                        görüntülediğiniz ve ziyaretinizin süresi
                                        gibi internet sitesini nasıl
                                        kullandığınızın tespiti de dahil olmak
                                        üzere; internet sitesini nasıl
                                        kullandığınızı belirlemek ve sonraki
                                        kullanımlar için kullanımınızı
                                        kişiselleştirmeyi sağlamak,
                                    </Text3>
                                    <Text3>
                                        • İnternet Sitesinin, sizin ve
                                        Şirketimizin hukuki ve ticari
                                        güvenliğini temin etmek.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>1. ÇEREZ TÜRLERİ</Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Çerezler; kullanım amaçlarına göre,
                                        saklanma sürelerine, kaynaklarına göre
                                        sınıflandırılmaktadır.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Kullanım Amaçlarına Göre Çerezler
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        <Caption>Zorunlu Çerezler: </Caption>{' '}
                                        İnternet sitesinin amaçlandığı gibi
                                        kullanılabilmesi için gerekli olan
                                        çerezlerdir. Bu çerezler pazarlama
                                        amacıyla kullanılamazlar ve ziyaretçi
                                        tarafından engellenmesi durumunda
                                        internet sitesinin bazı bölümleri
                                        çalışmayacaktır.
                                    </Text3>
                                    <Text3>
                                        <Caption>İşlevsel Çerezler: </Caption>
                                        İnternet sitesinin içeriğinin
                                        ziyaretçiye özel bireyselleştirilmesini
                                        ve tercihlerin hatırlanmasını
                                        sağlamaktadır. Ziyaretçi istediği zaman
                                        bu çerezlerin kullanımını
                                        engelleyebilmektedir.
                                    </Text3>
                                    <Text3>
                                        <Caption>
                                            Performans Çerezleri:{' '}
                                        </Caption>
                                        İnternet sitesini geliştirmeye yardımcı
                                        olan bu çerezler, kullanıcıların
                                        davranışlarını analiz etmek amacıyla
                                        istatistiki ölçümüne imkân veren
                                        çerezler olup sitenin ne şekilde ve ne
                                        kadar süre kullanıldığı gibi bilgileri
                                        içermektedir.
                                    </Text3>
                                    <Text3>
                                        <Caption>Pazarlama Çerezleri: </Caption>
                                        Ziyaretçilerin ilgi alanlarına göre
                                        uygun içerikleri barındırır davranışsal
                                        reklamları sunma amacıyla depolanan
                                        çerezlerdir. Bu çerezlerin kullanımının
                                        engellenmesi mümkündür.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Saklama Sürelerine Göre Çerezler
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        <Caption>Oturum Çerezleri: </Caption>
                                        Ziyaretçinin internet tarayıcısını
                                        kullandığı süre içerisinde
                                        hareketlerinin tanınmasını sağlayan ve
                                        tarayıcının kapatılması ile birlikte
                                        cihazda kaydedilmeyen çerezlerdir.
                                    </Text3>
                                    <Text3>
                                        <Caption>Kalıcı Çerezler: </Caption>
                                        Ziyaretçinin tercihlerinin hatırlanması
                                        amacıyla kullanılan ve belirli bir
                                        tarihte veya belirli bir süre sonra
                                        kendiliğinden silinen veya ziyaretçi
                                        tarafından silininceye kadar depolanan
                                        çerezlerdir. Ziyaretçi istediği zaman bu
                                        çerezleri silebilir.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Kaynaklarına Göre Çerezler
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        <Caption>
                                            Birinci Taraf Çerezler:
                                        </Caption>
                                        Ziyaret edilen internet sitesi
                                        tarafından oluşturulan çerezlerdir.
                                    </Text3>
                                    <Text3>
                                        <Caption>
                                            Üçüncü Taraf Çerezler:
                                        </Caption>
                                        Diğer sitelere ait eklentilerin ziyaret
                                        edilen internet sitesinde barınması
                                        sonucu diğer siteler, iş ortakları veya
                                        servis sağlayıcıları tarafından
                                        oluşturulan çerezlerdir.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>1. ÇEREZ YÖNETİMİ</Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Genel olarak web tarayıcıları otomatik
                                        olarak çerezleri kabul edecek şekilde
                                        çalışmaktadır. Tarayıcıların sunmuş
                                        olduğu imkânlara göre farklılık
                                        gösterebilmekle birlikte, siz veri
                                        sahiplerinin çerezlerin kullanılmasını
                                        engelleme, çerez kullanılmadan önce
                                        uyarı almayı tercih etme veya bazı
                                        çerezleri devre dışı bırakma ya da silme
                                        imkânları bulunmaktadır. <br />
                                        Çerezlere ilişkin tercihlerin,
                                        kullanıcının siteye erişim sağladığı her
                                        bir cihaz özelinde ayrı ayrı yapılması
                                        gerekebilecektir.
                                        <br />
                                        İnternet tarayıcınızın çeşidine göre
                                        aşağıda yer alan tablodaki ilgili
                                        linklere tıklayarak çerezler hakkında
                                        bilgi edinip izin verme veya reddetme
                                        hakkınızı kullanabilirsiniz.
                                    </Text3>
                                    <Text3>
                                        Örnek olarak, <br />
                                        &#34;Google Chrome -&gt; Ayarlar -&gt;
                                        Gelişmiş -&gt; Gizlilik ve Güvenlik
                                        -&gt; Site Ayarları -&gt; Çerezler ve
                                        Site Verileri -&gt; Sitelerin çerez
                                        verilerini kaydetmelerine ve okumalarına
                                        izin ver&#34; seçeneği ile
                                        yönetebilirsiniz.
                                        <br />
                                        &#34;Internet Explorer -&gt; Ayarlar
                                        -&gt; İnternet Seçenekleri -&gt;
                                        Gizlilik -&gt; Gelişmiş ayarlar&#34;
                                        menüsünden yönetebilirsiniz.
                                    </Text3>
                                    <Text3>
                                        Mobil Cihazınızda Çerezleri Kontrol
                                        etmek için;
                                    </Text3>
                                    <Text3>
                                        Apple Cihazlarda;
                                        <br />
                                        &#34;Ayarlar -&gt; Safari -&gt; Geçmişi
                                        ve Web Sitesi Verilerini Sil&#34;
                                        adımları ile tarama geçmişinizi ve
                                        çerezleri temizleyebilirsiniz.
                                        <br />
                                        Çerezleri silip geçmişinizi tutmak için
                                        &#34;Ayarlar -&gt; Safari -&gt; İleri
                                        Düzey -&gt; Web Sitesi Verileri -&gt;
                                        Tüm Web Sitesi Verilerini Sil&#34;
                                        adımlarını izleyebilirsiniz.
                                    </Text3>
                                    <Text3>
                                        Siteleri ziyaret ederken geçmiş
                                        verilerinin tutulmasını istemiyorsanız;
                                        <br />
                                        &#34;Safari -&gt;Sekme simgesi -&gt;
                                        Özel -&gt; Bitti&#34; adımlarını
                                        izleyerek özel dolaşımı aktif hale
                                        getirebilirsiniz.
                                        <br />
                                        &#34;Ayarlar -&gt; Safari -&gt; Tüm
                                        Çerezleri Engelle&#34; adımları ile
                                        çerezleri engelleyebilirsiniz. Ancak;
                                        çerezleri engellediğinizde bazı web
                                        siteleri ve özellikler düzgün
                                        çalışmayabilir.
                                    </Text3>
                                    <Text3>
                                        Android Cihazlarda;
                                        <br />
                                        &#34;Chrome uygulaması -&gt; Ayarlar
                                        -&gt; Gizlilik -&gt; Tarama verilerini
                                        temizle -&gt; Çerezler, medya lisansları
                                        ve site verileri -&gt; Verileri
                                        Temizle&#34; seçeneği ile çerezlerinizi
                                        temizleyebilirsiniz.
                                        <br />
                                        &#34;Chrome Uygulaması -&gt; Ayarlar
                                        -&gt; Site Ayarları -&gt; Çerezler&#34;
                                        seçeneği ile çerezlere izin verebilir
                                        veya engelleyebilirsiniz.
                                    </Text3>
                                    <MarginWrapper>
                                        <table
                                            border="1"
                                            width="100%"
                                            cellSpacing="0"
                                            cellPadding="0"
                                            table-layout="fixed"
                                        >
                                            <tbody>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3>
                                                            TARAYICI TÜRÜ
                                                        </Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            BİLGİLENDİRME
                                                            BAĞLANTISI
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3>
                                                            Adobe Analytics
                                                        </Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            http://www.adobe.com/uk/privacy/opt-out.html
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3> AOL</Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            https://help.aol.com/articles/restore-security-settings-and-enable-cookie-settings-on-browser
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3>
                                                            Google Adwords
                                                        </Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            https://support.google.com/ads/answer/2662922?hl=en
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3>
                                                            Google Analytics
                                                        </Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            https://tools.google.com/dlpage/gaoptout
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3>
                                                            Google Chrome
                                                        </Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            http://www.google.com/support/chrome/bin/answer.py?hl=en&answer=95647
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3>
                                                            Internet Explorer
                                                        </Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3>
                                                            Mozilla Firefox
                                                        </Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            http://support.mozilla.com/en-US/kb/Cookies
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3>Opera</Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            http://www.opera.com/browser/tutorials/security/privacy
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3> Safari</Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            https://support.apple.com/kb/ph19214?locale=tr_TR
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        <Text3>
                                                            Diğer Browser’lar
                                                        </Text3>
                                                    </td>
                                                    <td>
                                                        <Text3>
                                                            İlgili Browser’ların
                                                            yardım veya destek
                                                            sayfalarını
                                                            inceleyebilirsiniz.
                                                        </Text3>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </MarginWrapper>
                                    <Text3>
                                        Yukarıdaki seçeneklerin yanı sıra; tüm
                                        çerezler hakkında bilgi sahibi olmak ve
                                        çerez yönetimi için:
                                        https://www.allaboutcookies.org/verify
                                        ya da https://www.youronlinechoices.eu/
                                        internet adreslerini ziyaret
                                        edebilirsiniz veya “Privacy Badger”
                                        uygulamasını kullanabilirsiniz.
                                        (https://www.eff.org/tr/privacybadger)
                                    </Text3>
                                    <Text3>
                                        İnternet sitemizde kullanılan çerezleri
                                        engellemeniz halinde internet sitemizden
                                        alınan verimin düşeceğini, internet
                                        sitemizin tüm işlevlerine
                                        erişemeyebileceğinizi veya erişiminizin
                                        sınırlı olabileceğini dolayısıyla
                                        internet sitemizin düzgün
                                        çalışmayabileceğini bilgilerinize
                                        sunarız.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            1. KULLANMAKTA OLDUĞUMUZ ÇEREZLER
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Sitemizde kullanmakta olduğumuz farklı
                                        türlerdeki çerezler aşağıdaki tabloda
                                        yer almaktadır.
                                    </Text3>
                                    <MarginWrapper>
                                        <table
                                            border="1"
                                            width="100%"
                                            cellSpacing="0"
                                            cellPadding="0"
                                        >
                                            <tbody>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            Çerez İsmi
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            Çerez Amacı
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            Çerez Kategorisi
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            Çerez Süresi
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            Çerez Tipi
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>DSID</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Kullanıcıyı
                                                            tanımlamak ve
                                                            kullanıcının reklam
                                                            kişiselleştirmeyi
                                                            kabul edip
                                                            etmediğini
                                                            hatırlamak için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Gerekli</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>14 gün</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>IDE</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Reklam sunmak ve
                                                            oluşturmak,
                                                            reklamları
                                                            kişiselleştirme,
                                                            reklamı kullanıcıya
                                                            gösterme sayısını
                                                            sınırlamak, görmek
                                                            istenmediği
                                                            belirtilen
                                                            reklamların
                                                            gösterimini
                                                            engellemek ve
                                                            reklamların
                                                            etkinliğini ölçmek
                                                            amacıyla Google dışı
                                                            sitelerde Google
                                                            reklamlarını
                                                            düzenlemek için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>2 yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>datr</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Dolandırıcılık
                                                            önlemek için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>2 yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>dpr</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Cihazınız için en
                                                            iyi deneyimi
                                                            sağlamak amaçlı
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>7 Gün</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>fr</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Seçili Facebook
                                                            kullanıcılarını
                                                            reklam dağıtmı
                                                            amaçlı kullanılan
                                                            bir çerez.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>3 Ay</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>sb</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Tarayıcı detaylarını
                                                            sakla öğrenmek için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>2 Yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>1P_JAR</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Son aramalara ve
                                                            önceki etkileşimlere
                                                            dayanarak Google
                                                            tarafından Google
                                                            sitelerinde
                                                            kişiselleştirilmiş
                                                            reklamlar
                                                            görüntülemek için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>1 Ay</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>NID</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Oturumu kapalı
                                                            kullanıcılara Google
                                                            hizmetlerinde Google
                                                            reklamlarını
                                                            göstermek için
                                                            kullanılır. Başka
                                                            bir sayfaya
                                                            geçilince bu
                                                            bilgiler ile
                                                            kıyaslar ve anlar.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>6 Ay</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            Conversion
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Web sitesini ziyaret
                                                            eden kullanıcıyı
                                                            yeniden hedeflemeye
                                                            yarar.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>1 Ay</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            1. Parti Çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>CURRENCY</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Bu çerez, hangi para
                                                            birimi
                                                            kullanılacağını
                                                            belirtmektedir.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>1 Ay</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            1. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            NEXT_LOCALE
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Her zaman
                                                            kullanıcının seçtiği
                                                            dili sağlayarak
                                                            kullanıcı deneyimini
                                                            iyileştirebilmek
                                                            için kullanıcının
                                                            tarama dilini takip
                                                            etmek için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Gerekli</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Oturum</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            1. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>_fbp</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Facebook tarafından,
                                                            websiteleri
                                                            arasındaki
                                                            ziyaretleri izler ve
                                                            barındırır.{' '}
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>3 ay</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>_ga</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            İnternet Sitesi ve
                                                            Online İşlem
                                                            Merkezinde,
                                                            kullanıcıları ayırt
                                                            etmek, önceki
                                                            ziyaret sayısını ve
                                                            zamanını hatırlamak,
                                                            bir kullanıcının
                                                            internet sitesinde
                                                            ne kadar süreyle
                                                            kaldığını tespit
                                                            etmek ve
                                                            kullanıcının hangi
                                                            siteden geldiğini
                                                            (örneğin bir arama
                                                            motoru, başka bir
                                                            site veya doğrudan
                                                            tarayıcıya bir adres
                                                            girerek) hatırlamak
                                                            için
                                                            kullanılmaktadır.{' '}
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            Performans
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>2 yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            _ga_MZEK6MHKVC
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Kullanıcıları
                                                            tanımlamak ve ayırt
                                                            etmek için
                                                            kullanılır.{' '}
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>2 yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            _gac_UA-99791344-1
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Kullanıcı için
                                                            kampanyayla ilgili
                                                            bilgileri içerir.
                                                            Google Analytics ve
                                                            Google Ads
                                                            hesaplarınızı
                                                            bağladıysanız, siz
                                                            devre dışı
                                                            bırakmadığınız
                                                            sürece Google Ads
                                                            web sitesi dönüşüm
                                                            etiketleri bu çerezi
                                                            okuyacaktır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Oturum</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            _gat_gtag_UA_99791344_1
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Ziyaretçilerin web
                                                            sitemizi nasıl
                                                            kullandığı hakkında
                                                            bilgi toplamak için
                                                            kullanılır. Bu
                                                            bilgileri raporları
                                                            derlemek ve web
                                                            sitesini
                                                            geliştirmemize
                                                            yardımcı olmak için
                                                            kullanırız.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>2 Yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>_gcl_au</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Google AdSense
                                                            tarafından, Google
                                                            AdSense hizmetlerini
                                                            kullanan internet
                                                            sitelerindeki reklam
                                                            verimliliğini
                                                            ölçümlemek için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Kalıcı</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>_gcl_aw</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Tıklama bilgileri
                                                            için dönüşüm
                                                            bağlayıcı tarafından
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>90 gün</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>_gid</Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            İnternet Sitesi ve
                                                            Online İşlem
                                                            Merkezinde sayfa
                                                            görüntülenme
                                                            sayılarını saymak ve
                                                            bunları kaydetmek
                                                            için kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>24 Saat</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            _hjAbsoluteSessionInProgress
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Bu çerez, bir
                                                            kullanıcının ilk
                                                            sayfa görüntüleme
                                                            oturumunu tespit
                                                            etmek için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            İstatistik
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Oturum</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            _hjSessionUser_2334524
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Her kullanıcı için
                                                            özel atanmış ID’leri
                                                            saklar.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>1 Yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            _hjSession_2334524
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Sayfalar arasındaki
                                                            işlevselliği sağlar.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Oturum</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            <strong>
                                                                3. Parti çerez
                                                            </strong>
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            _hjTLDTest
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Hotjar komut dosyası
                                                            çalıştırıldığında,
                                                            sayfa ana bilgisayar
                                                            adı yerine
                                                            kullanmamız gereken
                                                            en genel tanımlama
                                                            bilgisi yolunu
                                                            belirlemeye
                                                            çalışırız. Bu,
                                                            çerezlerin alt
                                                            alanlar arasında
                                                            paylaşılabilmesi
                                                            için yapılır
                                                            (varsa). Bunu
                                                            belirlemek için,
                                                            başarısız olana
                                                            kadar farklı URL alt
                                                            dize alternatifleri
                                                            için _hjTLDTest
                                                            çerezini saklamaya
                                                            çalışıyoruz. Bu
                                                            kontrolden sonra
                                                            çerez kaldırılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Oturum</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            basket-cookie
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Kullanıcının
                                                            sepetinde hangi
                                                            ürünleri tuttuğunu
                                                            kaydetmek için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>24 Saat</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            1. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            _hjIncludedInSessionSample
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Ziyaretçilerin web
                                                            sitesi davranışına
                                                            ilişkin verileri
                                                            kaydeder. Bu, dahili
                                                            analiz ve web sitesi
                                                            optimizasyonu için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            İstatistik
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>30 dakika</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            rememberMe
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Kullanıcının oturum
                                                            bilgilerinin
                                                            kaydedilebilmesi
                                                            için kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Oturum</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            1. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            user_cookie
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Kullanıcının hangi
                                                            çerezleri kabul
                                                            ettiğini anlamak
                                                            için kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>45 gün</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            1. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            user_token
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Kullanıcının giriş
                                                            yapıp yapmadığı
                                                            durumunu kontrol
                                                            edip, kimlik
                                                            doğrulama işlevi
                                                            için kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Oturum</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            1. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            __Secure-3PAPISID
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Kişiselleştirilmiş
                                                            reklamlar göstermek
                                                            için web sitesi
                                                            ziyaretçilerinin
                                                            ilgi alanlarını
                                                            gösteren bir profil
                                                            oluşturur.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>2 yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            __Secure-3PSID
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Kişiselleştirilmiş
                                                            reklamlar göstermek
                                                            için web sitesi
                                                            ziyaretçilerinin
                                                            ilgi alanlarını
                                                            gösteren bir profil
                                                            oluşturur.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>2 yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            __Secure-3PSIDCC
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Bir kullanıcı
                                                            profili oluşturmak
                                                            ve kullanıcıya
                                                            alakalı ve
                                                            kişiselleştirilmiş
                                                            Google Reklamları
                                                            görüntülemek için
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Pazarlama</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>2 yıl</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        width="max-content"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            _hjFirstSeen
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="max-content"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Yeni kullanıcının
                                                            ilk kez girişini
                                                            ayırt etmek ve
                                                            tanımlamak için
                                                            kullanılır
                                                        </Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>İşlevsel</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>Oturum</Text3>
                                                    </td>
                                                    <td width="max-content">
                                                        <Text3>
                                                            3. Parti çerez
                                                        </Text3>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </MarginWrapper>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            1.1. Arka Planda Çalışan Çerez
                                            Benzeri Servisler
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <MarginWrapper>
                                        <table
                                            border="1"
                                            width="100%"
                                            cellSpacing="0"
                                            cellPadding="0"
                                        >
                                            <tbody>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            Servis İsmi
                                                        </Text3>
                                                    </td>
                                                    <td width="109">
                                                        <Text3>
                                                            Servis Amacı
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>
                                                            Saklama Süresi
                                                        </Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>Sentry</Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Sentry, Javascript,
                                                            Ruby, PHP gibi çok
                                                            çeşitli diller için
                                                            bir hata izleme
                                                            yazılımıdır.
                                                            Hatalarla ilgili
                                                            yığın izleri,
                                                            bağlamlar ve daha
                                                            fazlasını otomatik
                                                            olarak sunar.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            Styled-components
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            styled-components,
                                                            bileşenleri
                                                            biçimlendirmek için
                                                            etiketli şablon
                                                            değişmezlerini
                                                            kullanır. Bileşenler
                                                            ve stiller
                                                            arasındaki eşlemeyi
                                                            kaldırır.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>Node.js</Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            NodeJS, son derece
                                                            hafif ve verimli
                                                            olan popüler bir
                                                            javascript
                                                            çalışmasıdır.
                                                            Mimarisi, olaya
                                                            dayalı, engelleme
                                                            yapmayan bir G/Ç
                                                            modeline
                                                            dayanmaktadır.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>Ubuntu</Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Ubuntu açık kaynaklı
                                                            bir işletim
                                                            sistemidir. Linux
                                                            tabanlı Ubuntu,
                                                            Masaüstü
                                                            Bilgisayarlarda,
                                                            Tablet Akıllı
                                                            Telefonlarda,
                                                            Bulutta ve IoT
                                                            cihazlarında
                                                            çalışır.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Nginx, açık kaynaklı
                                                            bir HTTP sunucusu,
                                                            ters proxy sunucusu
                                                            ve ayrıca bir posta
                                                            sunucusudur.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>Next.js</Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Next.js, sunucu
                                                            tarafı oluşturma ve
                                                            statik web siteleri
                                                            oluşturma gibi React
                                                            tabanlı web
                                                            uygulamaları
                                                            işlevlerini sağlayan
                                                            Node.js`nin üzerine
                                                            inşa edilmiş açık
                                                            kaynaklı bir
                                                            geliştirme
                                                            çerçevesidir.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>React</Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            React, kullanıcı
                                                            arayüzleri
                                                            oluşturmak için
                                                            kullanılan hızlı ve
                                                            basit bir JavaScript
                                                            kitaplığıdır.
                                                            Yeniden yüklenmeden
                                                            zamanla değişen Web
                                                            Uygulamaları
                                                            oluşturmak için
                                                            kullanılabilir.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            Google Tag Manager
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Google Tag Manager,
                                                            verimli analizler
                                                            için kurumsal
                                                            düzeyde bir etiket
                                                            yönetimi çözümüdür.
                                                            Üçüncü taraf
                                                            analizlerini
                                                            destekler ve
                                                            gelişmiş etiket
                                                            yönetimi
                                                            teknolojileri sunar.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>Facebook</Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Facebook, insanlarla
                                                            bağlantı kurmanızı
                                                            sağlayan bir sosyal
                                                            ağ ve sosyal medya
                                                            sitesidir.
                                                            İşletmeler ve
                                                            bireyler için
                                                            kitlelerini büyütmek
                                                            ve erişimlerini
                                                            genişletmek için çok
                                                            çeşitli hizmetler
                                                            sunar.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>Webpack</Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Webpack, JavaScript
                                                            ile yazılmış
                                                            uygulamalar için bir
                                                            modül
                                                            paketleyicidir.
                                                            Paketleri istek
                                                            üzerine yükler ve
                                                            bir tarayıcı
                                                            tarafından
                                                            işlendiğinde bir
                                                            sayfanın genel
                                                            yükleme süresini
                                                            verimli bir şekilde
                                                            iyileştirir.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            Google Remarketing
                                                            Tag
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Google Remarketing
                                                            Tag, sitedeki tüm
                                                            sayfalara tek bir
                                                            etiket yerleştirmeye
                                                            olanak tanıyarak
                                                            kolayca yeniden
                                                            pazarlama listeleri
                                                            oluşturmaya yardımcı
                                                            olur.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            Google Analytics
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Google Analytics,
                                                            web sitesi trafiğini
                                                            izleyen ve ölçen bir
                                                            web analizi
                                                            hizmetidir. Web
                                                            yöneticilerine
                                                            faydalı bilgiler
                                                            sağlayan gelişmiş
                                                            işlevlere sahip bir
                                                            dizi analiz
                                                            özelliğine sahiptir.
                                                            Ayrıca, Adwords ile
                                                            entegre edildikten
                                                            sonra Pazar Analizi
                                                            ve Dönüşüm hedefleri
                                                            belirlemek için de
                                                            kullanılır.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        width="109"
                                                        valign="top"
                                                    >
                                                        <Text3>
                                                            Facebook Pixel
                                                        </Text3>
                                                    </td>
                                                    <td
                                                        width="109"
                                                        valign="toText"
                                                    >
                                                        <Text3>
                                                            Facebook Pixel, esas
                                                            olarak dönüşüm
                                                            izleme, optimizasyon
                                                            ve yeniden pazarlama
                                                            için kullanılan bir
                                                            hizmettir.
                                                        </Text3>
                                                    </td>
                                                    <td width="110px">
                                                        <Text3>2 YIL</Text3>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </MarginWrapper>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            SOSYAL MEDYA EKLENTİLERİ
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        KEİKEİ, internet sitesine çeşitli sosyal
                                        medya eklentileri entegre edilmiştir.
                                        Entegre edilmiş sosyal medya
                                        butonlarından birine tıklandığında bazı
                                        bilgileriniz sosyal medya sağlayıcılarla
                                        paylaşılır.
                                    </Text3>
                                    <Text3>
                                        Aynı anda sosyal medya hesabında
                                        oturumunuz açıksa veya sosyal medya
                                        çerezleri tarayıcınızda kayıtlıysa,
                                        sosyal medya sağlayıcı internet
                                        sitemizdeki ziyareti tanıyabilir ve
                                        sosyal medya profilinizde bu
                                        aktiviteleri gösterebilir.
                                    </Text3>
                                    <Text3>
                                        Sosyal ağların KEİKEİ, internet sitesini
                                        ziyaretinizi kullanıcı hesaplarınızla
                                        ilişkilendirmesini önlemek için,
                                        internet sitemizi ziyaret etmeden önce
                                        kullanıcı hesabınızdan çıkış yapmanız
                                        gerekmektedir. KEİKEİ, internet sitesine
                                        entegre edilmiş olan sosyal medya
                                        eklentilerine ilişkin daha fazla bilgi
                                        için ilgili sosyal medyanın gizlilik
                                        politikasını okumanızı öneririz:
                                        <br />
                                        https://www.facebook.com/help/325807937506242
                                        <br />
                                        https://help.instagram.com/519522125107875
                                        <br />
                                        https://policies.google.com/privacy?hl=tr
                                    </Text3>
                                </StaticPagesTextContainer>
                            </StaticPageContainer>
                        </StaticPageWrapper>
                    </ContractPageLayout>
                ) : (
                    <ContractPageLayout title={t('cookiePolicy').toUpperCase()}>
                        <KVKKMenu activeMenu="cookie-policy" />
                        <StaticPageWrapper marginTop="0" marginTopMobile="0">
                            <BackButton
                                title={t('cookiePolicy').toUpperCase()}
                                tabletHide
                            />
                            <StaticPagesTextContainer>
                                <Text3>
                                    As Keikei Tekstil Ve Clothing Industry And
                                    Trade Joint Stock Company (“KEİKEİ” or
                                    “Company”), we use some cookies on our
                                    website https://www.keikei.com/
                                    (&#34;Website&#34;) within the scope of our
                                    activities in the internet environment. The
                                    purpose of this Cookie Policy is to explain
                                    to you which type of cookies we use and for
                                    what purposes, how we manage cookies, what
                                    actions you can take against cookies and
                                    how.
                                </Text3>
                                <MarginWrapper>
                                    <Subtitle3>• WHAT IS COOKIE?</Subtitle3>
                                </MarginWrapper>
                                <Text3>
                                    Cookies are text files, generally consisting
                                    of letters and numbers, that are saved on
                                    your computer (or other devices such as
                                    smart phone or tablet, etc.) by the websites
                                    you visit via browsers. Cookies are created
                                    by the servers that manage the website you
                                    visit and do not contain personal data about
                                    visitors, such as name, gender or address.
                                    When a connection is established between
                                    your browser and the server, the site
                                    recognizes you through cookies. In this way,
                                    the website can determine the content to be
                                    transmitted to you. Cookies are necessary
                                    and important as they make the site more
                                    useful and facilitate the use of the web.
                                </Text3>
                                <MarginWrapper>
                                    <Subtitle3>
                                        • THE PURPOSE OF USING COOKIES
                                    </Subtitle3>
                                </MarginWrapper>
                                <Text3>
                                    The main purposes of using cookies on our
                                    website are:
                                </Text3>
                                <Text3>
                                    • To improve the services offered to you by
                                    increasing the functionality and performance
                                    of the Website,
                                </Text3>
                                <Text3>
                                    • To collect statistical data on how the
                                    Website is used, thus improving the content
                                    of the Website and improving its operation,
                                </Text3>
                                <Text3>
                                    • Including how you use the website, such as
                                    what content you view on the Website and the
                                    duration of your visit; to determine how you
                                    use the website and to personalize your use
                                    for future uses,
                                </Text3>
                                <Text3>
                                    • To ensure the legal and commercial
                                    security of the Website, you and our
                                    Company.
                                </Text3>
                                <MarginWrapper>
                                    <Subtitle3>1. KINDS OF COOKIES</Subtitle3>
                                </MarginWrapper>
                                <Text3>
                                    Cookies are classified by purpose of use,
                                    storage time, source.
                                </Text3>
                                <MarginWrapper>
                                    <Subtitle3>
                                        Cookies by Purpose of Use
                                    </Subtitle3>
                                </MarginWrapper>
                                <Text3>
                                    <Caption>Necessary Cookies: </Caption>
                                    These are cookies that are necessary for the
                                    website to be used as intended. These
                                    cookies can not be used for marketing
                                    purposes and some parts of the website will
                                    not work if blocked by the visitor.
                                </Text3>
                                <Text3>
                                    <Caption>Functional Cookies: </Caption>
                                    It ensures that the content of the website
                                    is individualized for the visitor and that
                                    the preferences are remembered. The visitor
                                    can prevent the use of these cookies at any
                                    time.
                                </Text3>
                                <Text3>
                                    <Caption>Performance Cookies: </Caption>
                                    These cookies, which help to improve the
                                    website, are cookies that allow statistical
                                    measurement in order to analyze the behavior
                                    of users and contain information such as how
                                    and for how long the site is used.
                                </Text3>
                                <Text3>
                                    <Caption>Marketing Cookies: </Caption>
                                    They are cookies that are stored for the
                                    purpose of presenting behavioral
                                    advertisements that contain appropriate
                                    content according to the interests of the
                                    visitors. It is possible to prevent the use
                                    of these cookies.
                                </Text3>
                                <MarginWrapper>
                                    <Subtitle3>
                                        Cookies by Storage Time
                                    </Subtitle3>
                                </MarginWrapper>
                                <Text3>
                                    <Caption>Session Cookies: </Caption>
                                    These are cookies that allow the
                                    visitor&#39;s movements to be recognized
                                    while using the internet browser and are not
                                    saved on the device when the browser is
                                    closed.
                                </Text3>
                                <Text3>
                                    <Caption>Permanent Cookies: </Caption>
                                    These are cookies that are used to remember
                                    the visitor&#39;s preferences and are
                                    automatically deleted on a certain date or
                                    after a certain period of time or are stored
                                    until they are deleted by the visitor. The
                                    visitor can delete these cookies at any
                                    time.
                                </Text3>
                                <MarginWrapper>
                                    <Subtitle3>Cookies by Source</Subtitle3>
                                </MarginWrapper>
                                <Text3>
                                    <Caption>First Party Cookies: </Caption> The
                                    cookies are made by visited website
                                </Text3>
                                <Text3>
                                    <Caption>Third Party Cookies: </Caption>
                                    These are cookies created by other sites,
                                    business partners or service providers as a
                                    result of hosting plug-ins from other sites
                                    on the website visited.
                                </Text3>
                                <MarginWrapper>
                                    <Subtitle3>1. COOKIE MANAGEMENT</Subtitle3>
                                </MarginWrapper>
                                <Text3>
                                    In general, web browsers work to
                                    automatically accept cookies. Although it
                                    may differ according to the possibilities
                                    offered by the browsers, you, the data
                                    owner, have the opportunity to prevent the
                                    use of cookies, to receive a warning before
                                    the use of cookies, or to disable or delete
                                    some cookies.
                                    <br />
                                    Preferences for cookies may need to be made
                                    separately for each device from which the
                                    user accesses the site.
                                    <br />
                                    Depending on the type of your internet
                                    browser, you can get information about
                                    cookies by clicking on the relevant links in
                                    the table below and use your right to allow
                                    or reject cookies.
                                </Text3>
                                <Text3>
                                    For example,
                                    <br />
                                    You may manage with ”Google Chrome -&gt;Set
                                    up-&gt;advanced-&gt;privacy and
                                    security-&gt;site set up-&gt;cookies and
                                    site data-&gt; Allow sites to save and read
                                    cookie data” option.
                                    <br />
                                    You may manage with “Internet
                                    Explorer-&gt;set up-&gt;internet
                                    options-&gt;privacy-&gt;advanced sete up”
                                    menu.
                                </Text3>
                                <Text3>
                                    To Control Cookies on Mobile Device;
                                </Text3>
                                <Text3>
                                    Apple devices;
                                    <br />
                                    You may clear your history and cookies with
                                    “Set up-&gt;safari-&gt;delete the history
                                    and website datas” steps.
                                    <br />
                                    To delete the cookies without clearing your
                                    browsing history you may follow these steps
                                    : “Settings -&gt; Advanced -&gt; Website
                                    Data -&gt; Delete All Website Data”
                                </Text3>
                                <Text3>
                                    If you do not want historical data to be
                                    kept while visiting the sites;
                                    <br />
                                    You may activate private roaming by
                                    following “safari-&gt;tab symbol -&gt;
                                    private-&gt;done” steps.
                                    <br />
                                    You may block the cookies with “Set
                                    up-&gt;safari-&gt; block all cookies” steps.
                                    However; when you block cookies some
                                    websites and features may not work right.
                                </Text3>
                                <Text3>
                                    Android devices;
                                    <br />
                                    You may clear the cookies with “chrome
                                    application-&gt;set up-&gt;privacy-&gt;clear
                                    browse data-&gt;cookies, media
                                    licenses-&gt;clear datas” option.
                                    <br />
                                    you may permit or block with “chrome
                                    application-&gt;set up-&gt;site set
                                    up-&gt;cookies” option.
                                </Text3>

                                <table
                                    border="1"
                                    width="100%"
                                    cellSpacing="0"
                                    cellPadding="0"
                                    table-layout="fixed"
                                >
                                    <tbody>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong>
                                                        BROWSER TYPE
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        INFORMATION LINK
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong>
                                                        Adobe Analytics
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        http://www.adobe.com/uk/privacy/opt-out.html
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong> AOL</strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        https://help.aol.com/articles/restore-security-settings-and-enable-cookie-settings-on-browser
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong>
                                                        Google Adwords
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        https://support.google.com/ads/answer/2662922?hl=en
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong>
                                                        Google Analytics
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        https://tools.google.com/dlpage/gaoptout
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong>
                                                        Google Chrome
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        http://www.google.com/support/chrome/bin/answer.py?hl=en&answer=95647
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong>
                                                        Internet Explorer
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong>
                                                        Mozilla Firefox
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        http://support.mozilla.com/en-US/kb/Cookies
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong>Opera</strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        http://www.opera.com/browser/tutorials/security/privacy
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong> Safari</strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        https://support.apple.com/kb/ph19214?locale=tr_TR
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <Text3>
                                                    <strong>
                                                        Diğer Browser’lar
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td>
                                                <Text3>
                                                    <strong>
                                                        İlgili Browser’ların
                                                        yardım veya destek
                                                        sayfalarını
                                                        inceleyebilirsiniz.
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <Text3>
                                    In addition to the above options; You can
                                    visit https://www.allaboutcookies.org/verify
                                    or https://www.youronlinechoices.eu/ or use
                                    the &#34;Privacy Badger&#34; application to
                                    be informed about all cookies and to manage
                                    cookies.
                                    (https://www.eff.org/tr/privacybadger)
                                </Text3>
                                <Text3>
                                    We inform you that if you block the cookies
                                    used on our website, the efficiency of our
                                    website will decrease, you may not be able
                                    to access all functions of our website or
                                    your access may be limited, so our website
                                    may not work properly.
                                </Text3>
                                <MarginWrapper>
                                    <Subtitle3>
                                        1. KULLANMAKTA OLDUĞUMUZ ÇEREZLER
                                    </Subtitle3>
                                </MarginWrapper>
                                <Text3>
                                    Sitemizde kullanmakta olduğumuz farklı
                                    türlerdeki çerezler aşağıdaki tabloda yer
                                    almaktadır.
                                </Text3>

                                <table
                                    border="1"
                                    width="100%"
                                    cellSpacing="0"
                                    cellPadding="0"
                                >
                                    <tbody>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>Cookie Name</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        Purpose of Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        Cookie Category
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        Cookie Duration
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Cookie Type</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>DSID</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to identify
                                                        the user and remember
                                                        whether the user agrees
                                                        to ad personalization.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Necessary</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>14 Day</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>IDE</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to serve and
                                                        create advertisements,
                                                        personalize
                                                        advertisements, limit
                                                        the number of times the
                                                        advertisement is shown
                                                        to the user, prevent the
                                                        display of
                                                        advertisements specified
                                                        as undesirable, and
                                                        regulate Google
                                                        advertisements on
                                                        non-Google sites in
                                                        order to measure the
                                                        effectiveness of
                                                        advertisements.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>datr</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to prevent
                                                        fraud.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>dpr</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to provide
                                                        the best experience for
                                                        your device.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>7 day</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>fr</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        A cookie used to
                                                        advertise selected
                                                        Facebook users.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>3 Month</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>sb</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to learn
                                                        browser details.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>1P_JAR</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        Used by Google to
                                                        display personalized ads
                                                        on Google sites based on
                                                        recent searches and
                                                        previous interactions.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>1 Month</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>NID</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        Used to show Google ads
                                                        on Google services to
                                                        not signed-in users.
                                                        When you switch to
                                                        another page, it
                                                        compares and understands
                                                        this information.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>6 Month</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>Conversion</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It serves to retarget
                                                        the user visiting the
                                                        website.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>1 Month</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>CURRENCY</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        This cookie specifies
                                                        which currency to use.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>1 Month</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        1. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>NEXT_LOCALE</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to keep track
                                                        of the user&#39;s
                                                        browsing language so
                                                        that we can improve the
                                                        user experience by
                                                        always providing the
                                                        language chosen by the
                                                        user.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Necessary</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Session</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        1. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>_fbp</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        Used by Facebook to
                                                        deliver a range of
                                                        advertising products,
                                                        such as real-time
                                                        bidding from third-party
                                                        advertisers.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>3 Month</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>_ga</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        In the Website and
                                                        Online Transaction
                                                        Center, distinguishing
                                                        users, remembering the
                                                        number and time of
                                                        previous visits,
                                                        determining how long a
                                                        user has been on the
                                                        website, and remembering
                                                        from which site the user
                                                        came from (for example,
                                                        a search engine, another
                                                        site or by entering an
                                                        address directly in the
                                                        browser) used for.
                                                    </strong>{' '}
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Performance</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        _ga_MZEK6MHKVC
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to seperate
                                                        the users.
                                                    </strong>{' '}
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        _gac_UA-99791344-1
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        Contains information
                                                        about the campaign for
                                                        the user. If you have
                                                        linked your Google
                                                        Analytics and Google Ads
                                                        accounts, Google Ads
                                                        website conversion tags
                                                        will read this cookie
                                                        unless you disable it.
                                                    </strong>{' '}
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Session</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        _gat_gtag_UA_99791344_1
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to collect
                                                        information about how
                                                        visitors use our
                                                        website. We use this
                                                        information to compile
                                                        reports and to help us
                                                        improve the website.
                                                    </strong>{' '}
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>_gcl_au</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used by Google
                                                        AdSense to measure
                                                        advertising efficiency
                                                        on websites using Google
                                                        AdSense services.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Permanent</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>_gcl_aw</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        Cookies that create
                                                        unique IDs for visitors
                                                        to remember preferences
                                                        and track and collect
                                                        statistics and
                                                        conversion rates through
                                                        the website to store ad
                                                        click information.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>90 Day</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>_gid</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to count and
                                                        record the number of
                                                        page views in the
                                                        Website and Online
                                                        Action Center.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>1 Day</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        _hjAbsoluteSessionInProgress
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        This cookie is used to
                                                        detect a user&#39;s
                                                        first pageview session.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Statistic</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Session</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        _hjSessionUser_2334524
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It includes a unique
                                                        code for each customer
                                                        so that it knows where
                                                        to find the shopping
                                                        cart data for each
                                                        customer.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>1 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        _hjSession_2334524
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It provides the
                                                        functionality between
                                                        pages.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Session</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>_hjTLDTest</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        When the Hotjar script
                                                        is run, we try to
                                                        determine the most
                                                        common cookie path we
                                                        should use instead of
                                                        the page hostname. This
                                                        is done so that cookies
                                                        can be shared between
                                                        subdomains (if any). To
                                                        determine this, we try
                                                        to store the _hjTLDTest
                                                        cookie for different URL
                                                        substring alternatives
                                                        until we fail. After
                                                        this check, the cookie
                                                        is removed.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Session</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        basket-cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to record
                                                        which products the user
                                                        keeps in her cart.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>1 Day</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        1. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        _hjIncludedInSessionSample
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It records data on
                                                        website behavior of
                                                        visitors. This is used
                                                        for internal analysis
                                                        and website
                                                        optimization.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Statistic</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>30 Minute</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>rememberMe</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to save the
                                                        user&#39;s session
                                                        information.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Session</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        1. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>user_cookie</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to understand
                                                        which cookies the user
                                                        accepts.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>45 Day</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        1. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>user_token</strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used for
                                                        authentication function
                                                        by checking the
                                                        user&#39;s login status.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Session</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        1. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        __Secure-3PAPISID
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It creates a profile
                                                        that shows the interests
                                                        of website visitors to
                                                        show personalized ads.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        __Secure-3PSID
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It creates a profile
                                                        that shows the interests
                                                        of website visitors to
                                                        show personalized ads.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        __Secure-3PSIDCC
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        It is used to create a
                                                        user profile and display
                                                        relevant and
                                                        personalized Google Ads
                                                        to the user.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Marketing</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                width="max-content"
                                                valign="top"
                                            >
                                                <Text3>
                                                    <strong>
                                                        _hjFirstSeen
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td
                                                width="max-content"
                                                valign="toText"
                                            >
                                                <Text3>
                                                    <strong>
                                                        Used to distinguish and
                                                        identify a new
                                                        user&#39;s first time
                                                        login
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Functional</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>Session</strong>
                                                </Text3>
                                            </td>
                                            <td width="max-content">
                                                <Text3>
                                                    <strong>
                                                        3. Party Cookie
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <MarginWrapper>
                                    <Subtitle3>
                                        1.1. Cookie-Like Services Running in the
                                        Background
                                    </Subtitle3>
                                </MarginWrapper>

                                <table
                                    border="1"
                                    width="100%"
                                    cellSpacing="0"
                                    cellPadding="0"
                                >
                                    <tbody>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>
                                                        Service Name
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="109">
                                                <Text3>
                                                    <strong>
                                                        Service Purpose
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>
                                                        Storage Time
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>Sentry</strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        Sentry is a bug tracking
                                                        software for a wide
                                                        variety of languages
                                                        such as Javascript,
                                                        Ruby, PHP. It
                                                        automatically presents
                                                        stack traces of errors,
                                                        contexts and more.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">2 Year</td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>
                                                        Styled-components
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        styled-components uses
                                                        tagged template literals
                                                        to style components.
                                                        Removes the mapping
                                                        between components and
                                                        styles.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>Node.js</strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        NodeJS is a popular
                                                        javascript script that
                                                        is extremely lightweight
                                                        and efficient. Its
                                                        architecture is based on
                                                        an event-driven,
                                                        non-blocking G/Ç model.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>Ubuntu</strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        Ubuntu is an open source
                                                        operating system.
                                                        Linux-based Ubuntu runs
                                                        on Desktops, Tablet
                                                        Smartphones, Cloud and
                                                        IoT devices.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>Nginx</strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        Nginx is an open source
                                                        HTTP server, reverse
                                                        proxy server and also a
                                                        mail server.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>Next.js</strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        Next.js is an open
                                                        source development
                                                        framework built on top
                                                        of Node.js that provides
                                                        React-based web
                                                        applications
                                                        functionality such as
                                                        server-side rendering
                                                        and rendering static
                                                        websites.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>React</strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        React is a fast and
                                                        simple JavaScript
                                                        library for building
                                                        user interfaces. It can
                                                        be used to build
                                                        time-varying Web
                                                        Applications without
                                                        reloading.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>
                                                        Google Tag Manager
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        Google Tag Manager is an
                                                        enterprise-grade tag
                                                        management solution for
                                                        efficient analytics. It
                                                        supports third-party
                                                        analytics and offers
                                                        advanced tag management
                                                        technologies.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>Facebook</strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        Facebook is a social
                                                        networking and social
                                                        media site that allows
                                                        you to connect with
                                                        people. It offers a wide
                                                        range of services for
                                                        businesses and
                                                        individuals to grow
                                                        their audience and
                                                        expand their reach.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>Webpack</strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        Webpack is a module
                                                        packager for
                                                        applications written in
                                                        JavaScript. It installs
                                                        packages on demand and
                                                        efficiently improves a
                                                        page&#39;s overall load
                                                        time when rendered by a
                                                        browser.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>
                                                        Google Remarketing Tag
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        The Google Remarketing
                                                        Tag helps to easily
                                                        create remarketing lists
                                                        by allowing a single tag
                                                        to be placed on all
                                                        pages on the site.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>
                                                        Google Analytics
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        Google Analytics is a
                                                        web analytics service
                                                        that monitors and
                                                        measures website
                                                        traffic. It has a set of
                                                        analytics features with
                                                        advanced functions that
                                                        provide useful
                                                        information to
                                                        webmasters. It is also
                                                        used to set Market
                                                        Analysis and Conversion
                                                        targets after
                                                        integrating with
                                                        AdWords.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="109" valign="top">
                                                <Text3>
                                                    <strong>
                                                        Facebook Pixel
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        Facebook Pixel is a
                                                        service mainly used for
                                                        converasion tracking,
                                                        optimization and
                                                        remarketing.
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="110px">
                                                <Text3>
                                                    <strong>2 Year</strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <MarginWrapper>
                                    <Subtitle3>SOCIAL MEDIA PLUGS</Subtitle3>
                                </MarginWrapper>
                                <Text3>
                                    Various social media plugins have been
                                    integrated into the KEIKEI website. When one
                                    of the integrated social media buttons is
                                    clicked, some of your information is shared
                                    with social media providers.
                                </Text3>
                                <Text3>
                                    If you are logged in to the social media
                                    account at the same time or social media
                                    cookies are saved in your browser, the
                                    social media provider can recognize the
                                    visit to our website and show these
                                    activities on your social media profile.
                                </Text3>
                                <Text3>
                                    In order to prevent social networks from
                                    associating your visit to the KEIKEI website
                                    with your user accounts, you must log out of
                                    your user account before visiting our
                                    website. For more information on the social
                                    media plug-ins integrated into the KEIKEI
                                    website, we recommend that you read the
                                    privacy policy of the relevant social media:
                                    <br />
                                    https://www.facebook.com/help/325807937506242
                                    <br />
                                    https://help.instagram.com/519522125107875
                                    <br />
                                    https://policies.google.com/privacy?hl=tr
                                </Text3>
                            </StaticPagesTextContainer>
                        </StaticPageWrapper>
                    </ContractPageLayout>
                )}
            </AgreementModalWrapper>
        </div>
    );
};

const MarginWrapper = styled.div`
    margin: 10px 0;
`;
export default CookiePolicy;
